import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import { equipmentsSensorTypeSummaryQuery } from '../../services/useEquipmentsSensorTypeSummaryQuery';
import style from './style.module.scss';

const SensorTypeSummaryPanel = () => {
  const { t } = useTranslation();

  const locationSelectValue = selectAppLocationSelectValue();

  const { data: summaryData, isLoading } = equipmentsSensorTypeSummaryQuery({
    locationIds:
      locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue?.filterIds,
  });

  return (
    <div className={style.summaryPanel}>
      {isLoading ? (
        <SkeletonBlock className={style.skeletonTitleText} />
      ) : (
        <>
          <div className={style.totalSensors}>
            <div className={style.totalLabel}>{t('Total count of each sensor type:')}</div>
            <div className={style.summaryValue}>{summaryData?.total}</div>
          </div>
          <div className={style.sensorSummaryList}>
            {summaryData?.data.map((sensor) => (
              <div className={style.sensorSummary} key={uuidv4()}>
                <div className={style.summaryValue}>{sensor.count}</div>
                <div className={style.totalLabel}>{sensor.name}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SensorTypeSummaryPanel;
